import React, { useState, memo } from "react";

const Pagination = ({ count, page, limit, setPageDoc, setPagination }) => {

    const indexOfFirst = (page - 1) * limit + 1;
    const indexOfLast = Math.min(page * limit, count);
    const totalPages = Math.ceil(count / limit);

    const handlePageChange = (page) => {
        setPageDoc(prevState => ({ ...prevState, ...{ page } }));
        setPagination(prevState => ({ ...prevState, ...{ page } }));
    };

    const getPaginationButtons = () => {
        const buttons = [];
        const maxButtons = 5;
        let startPage = Math.max(1, page - Math.floor(maxButtons / 2));
        let endPage = Math.min(totalPages, startPage + maxButtons - 1);

        if (endPage - startPage < maxButtons - 1) {
            startPage = Math.max(1, endPage - maxButtons + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            buttons.push(i);
        }

        return buttons;
    };
    
    return (
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                <div className="text-sm text-gray-600">
                    Showing {indexOfFirst} to {indexOfLast} of {count} records
                </div>
                <div className="flex gap-2 flex-wrap justify-center">
                    <button
                        onClick={() => handlePageChange(1)}
                        disabled={page === 1}
                        className="px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                    >
                        First
                    </button>
                    <button
                        onClick={() => handlePageChange(page - 1)}
                        disabled={page === 1}
                        className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Previous
                    </button>

                    {getPaginationButtons().map((pageNum) => (
                        <button
                            key={pageNum}
                            onClick={() => handlePageChange(pageNum)}
                            className={`px-4 py-2 rounded-lg ${page === pageNum
                                ? 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white'
                                : 'border border-gray-300 hover:bg-gray-100'
                                }`}
                            disabled={page === pageNum}
                        >
                            {pageNum}
                        </button>
                    ))}

                    <button
                        onClick={() => handlePageChange(page + 1)}
                        disabled={page === totalPages}
                        className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Next
                    </button>
                    <button
                        onClick={() => handlePageChange(totalPages)}
                        disabled={page === totalPages}
                        className="px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                    >
                        Last
                    </button>
                </div>
            </div>
        </div>
    )
}

export default memo(Pagination);